import React from 'react';
import { EditTitle } from '../../../components/AppBar/Titles';
import RichTextInput from 'components/Fields/Inputs/RichTextInput';
import { Edit, SimpleForm, TextInput, required } from 'react-admin';
import { EditToolbar } from '../../../components/Toolbar/EditToolbar';

export const StoriesEdit = (props) => {
	return (
		<>
			<Edit title={<EditTitle source='name' />} {...props}>
				<SimpleForm variant='standard' margin='normal' toolbar={<EditToolbar />}>
						<TextInput source='name' validate={required()} fullWidth />
						<RichTextInput source='description' label='Description'/>
				</SimpleForm>
			</Edit>
		</>
	);
}
